export default {
  default: () => import("C:/Users/gyu.zo/Documents/GitHub/POLIOL_HONLAP/layouts/default.vue").then(m => m.default || m)
}